export type FormLanguage = 'am' | 'ar' | 'bn' | 'de' | 'en' | 'es' | 'et' | 'fil' | 'fr' | 'hi' | 'id' | 'ja' | 'ko' | 'pt' | 'ru' | 'sw' | 'vi' | 'zh';

export type FormString = 'back' | 'close' | 'closed' | 'failed' | 'invalid' | 'next' | 'poweredBy' | 'required' | 'sending' | 'step' | 'submit' | 'thanks';

/** The renderer's own chrome, by the page's language. */
export const FORM_STRINGS: Record<FormLanguage, Record<FormString, string>> = {
  am: {
    back: 'ተመለስ',
    close: 'ዝጋ',
    closed: 'ይህ ቅጽ አሁን ምላሾችን አይቀበልም።',
    failed: 'መላክ አልተቻለም። እንደገና ይሞክሩ።',
    invalid: 'ይህ መልስ አይቀበልም።',
    next: 'ቀጣይ',
    poweredBy: 'በProdantix የተሰራ',
    required: 'ይህ ያስፈልጋል።',
    sending: 'በመላክ ላይ…',
    step: 'ደረጃ {step} ከ{total}',
    submit: 'ላክ',
    thanks: 'እናመሰግናለን።',
  },
  ar: {
    back: 'رجوع',
    close: 'إغلاق',
    closed: 'لا يقبل هذا النموذج ردودًا الآن.',
    failed: 'تعذّر الإرسال. حاول مرة أخرى.',
    invalid: 'هذه الإجابة غير مقبولة.',
    next: 'التالي',
    poweredBy: 'مدعوم من Prodantix',
    required: 'هذا الحقل مطلوب.',
    sending: 'جارٍ الإرسال…',
    step: 'الخطوة {step} من {total}',
    submit: 'إرسال',
    thanks: 'شكرًا لك.',
  },
  bn: {
    back: 'পেছনে',
    close: 'বন্ধ করুন',
    closed: 'এই ফর্মটি এখন উত্তর নিচ্ছে না।',
    failed: 'পাঠানো যায়নি। আবার চেষ্টা করুন।',
    invalid: 'এই উত্তরটি গ্রহণযোগ্য নয়।',
    next: 'পরবর্তী',
    poweredBy: 'Prodantix দ্বারা চালিত',
    required: 'এটি আবশ্যক।',
    sending: 'পাঠানো হচ্ছে…',
    step: 'ধাপ {step} / {total}',
    submit: 'জমা দিন',
    thanks: 'ধন্যবাদ।',
  },
  de: {
    back: 'Zurück',
    close: 'Schließen',
    closed: 'Dieses Formular nimmt gerade keine Antworten an.',
    failed: 'Senden fehlgeschlagen. Bitte erneut versuchen.',
    invalid: 'Diese Antwort wird nicht angenommen.',
    next: 'Weiter',
    poweredBy: 'Bereitgestellt von Prodantix',
    required: 'Dieses Feld ist erforderlich.',
    sending: 'Wird gesendet…',
    step: 'Schritt {step} von {total}',
    submit: 'Absenden',
    thanks: 'Vielen Dank.',
  },
  en: {
    back: 'Back',
    close: 'Close',
    closed: 'This form is not accepting responses right now.',
    failed: 'This could not be sent. Try again.',
    invalid: 'This answer is not accepted.',
    next: 'Next',
    poweredBy: 'Powered by Prodantix',
    required: 'This is required.',
    sending: 'Sending…',
    step: 'Step {step} of {total}',
    submit: 'Submit',
    thanks: 'Thank you.',
  },
  es: {
    back: 'Atrás',
    close: 'Cerrar',
    closed: 'Este formulario no acepta respuestas ahora.',
    failed: 'No se pudo enviar. Inténtalo de nuevo.',
    invalid: 'Esta respuesta no se acepta.',
    next: 'Siguiente',
    poweredBy: 'Con la tecnología de Prodantix',
    required: 'Este campo es obligatorio.',
    sending: 'Enviando…',
    step: 'Paso {step} de {total}',
    submit: 'Enviar',
    thanks: 'Gracias.',
  },
  et: {
    back: 'Tagasi',
    close: 'Sulge',
    closed: 'See vorm ei võta praegu vastuseid vastu.',
    failed: 'Saatmine ebaõnnestus. Proovi uuesti.',
    invalid: 'Seda vastust ei võeta vastu.',
    next: 'Edasi',
    poweredBy: 'Toetab Prodantix',
    required: 'See on kohustuslik.',
    sending: 'Saatmine…',
    step: 'Samm {step}/{total}',
    submit: 'Saada',
    thanks: 'Aitäh.',
  },
  fil: {
    back: 'Bumalik',
    close: 'Isara',
    closed: 'Hindi tumatanggap ng sagot ang form na ito ngayon.',
    failed: 'Hindi naipadala. Subukan ulit.',
    invalid: 'Hindi tinatanggap ang sagot na ito.',
    next: 'Susunod',
    poweredBy: 'Pinapagana ng Prodantix',
    required: 'Kailangan ito.',
    sending: 'Ipinapadala…',
    step: 'Hakbang {step} sa {total}',
    submit: 'Ipadala',
    thanks: 'Salamat.',
  },
  fr: {
    back: 'Retour',
    close: 'Fermer',
    closed: 'Ce formulaire n’accepte plus de réponses pour le moment.',
    failed: 'L’envoi a échoué. Réessayez.',
    invalid: 'Cette réponse n’est pas acceptée.',
    next: 'Suivant',
    poweredBy: 'Propulsé par Prodantix',
    required: 'Ce champ est obligatoire.',
    sending: 'Envoi…',
    step: 'Étape {step} sur {total}',
    submit: 'Envoyer',
    thanks: 'Merci.',
  },
  hi: {
    back: 'पीछे',
    close: 'बंद करें',
    closed: 'यह फ़ॉर्म अभी जवाब नहीं ले रहा है।',
    failed: 'भेजा नहीं जा सका। फिर कोशिश करें।',
    invalid: 'यह जवाब स्वीकार नहीं है।',
    next: 'आगे',
    poweredBy: 'Prodantix द्वारा संचालित',
    required: 'यह ज़रूरी है।',
    sending: 'भेजा जा रहा है…',
    step: 'चरण {step} / {total}',
    submit: 'भेजें',
    thanks: 'धन्यवाद।',
  },
  id: {
    back: 'Kembali',
    close: 'Tutup',
    closed: 'Formulir ini sedang tidak menerima tanggapan.',
    failed: 'Gagal mengirim. Coba lagi.',
    invalid: 'Jawaban ini tidak diterima.',
    next: 'Berikutnya',
    poweredBy: 'Didukung oleh Prodantix',
    required: 'Wajib diisi.',
    sending: 'Mengirim…',
    step: 'Langkah {step} dari {total}',
    submit: 'Kirim',
    thanks: 'Terima kasih.',
  },
  ja: {
    back: '戻る',
    close: '閉じる',
    closed: 'このフォームは現在回答を受け付けていません。',
    failed: '送信できませんでした。もう一度お試しください。',
    invalid: 'この回答は受け付けられません。',
    next: '次へ',
    poweredBy: 'Powered by Prodantix',
    required: '必須項目です。',
    sending: '送信中…',
    step: 'ステップ {step}/{total}',
    submit: '送信',
    thanks: 'ありがとうございました。',
  },
  ko: {
    back: '이전',
    close: '닫기',
    closed: '이 양식은 지금 응답을 받지 않습니다.',
    failed: '보내지 못했습니다. 다시 시도하세요.',
    invalid: '이 답변은 받을 수 없습니다.',
    next: '다음',
    poweredBy: 'Prodantix 제공',
    required: '필수 항목입니다.',
    sending: '보내는 중…',
    step: '{total}단계 중 {step}단계',
    submit: '제출',
    thanks: '감사합니다.',
  },
  pt: {
    back: 'Voltar',
    close: 'Fechar',
    closed: 'Este formulário não está a aceitar respostas neste momento.',
    failed: 'Não foi possível enviar. Tente novamente.',
    invalid: 'Esta resposta não é aceite.',
    next: 'Seguinte',
    poweredBy: 'Com tecnologia Prodantix',
    required: 'Este campo é obrigatório.',
    sending: 'A enviar…',
    step: 'Passo {step} de {total}',
    submit: 'Enviar',
    thanks: 'Obrigado.',
  },
  ru: {
    back: 'Назад',
    close: 'Закрыть',
    closed: 'Эта форма сейчас не принимает ответы.',
    failed: 'Не удалось отправить. Попробуйте ещё раз.',
    invalid: 'Этот ответ не принимается.',
    next: 'Далее',
    poweredBy: 'Работает на Prodantix',
    required: 'Это обязательное поле.',
    sending: 'Отправка…',
    step: 'Шаг {step} из {total}',
    submit: 'Отправить',
    thanks: 'Спасибо.',
  },
  sw: {
    back: 'Rudi',
    close: 'Funga',
    closed: 'Fomu hii haipokei majibu kwa sasa.',
    failed: 'Imeshindwa kutuma. Jaribu tena.',
    invalid: 'Jibu hili halikubaliki.',
    next: 'Endelea',
    poweredBy: 'Inaendeshwa na Prodantix',
    required: 'Hii inahitajika.',
    sending: 'Inatuma…',
    step: 'Hatua {step} kati ya {total}',
    submit: 'Tuma',
    thanks: 'Asante.',
  },
  vi: {
    back: 'Quay lại',
    close: 'Đóng',
    closed: 'Biểu mẫu này hiện không nhận câu trả lời.',
    failed: 'Không gửi được. Hãy thử lại.',
    invalid: 'Câu trả lời này không được chấp nhận.',
    next: 'Tiếp',
    poweredBy: 'Được hỗ trợ bởi Prodantix',
    required: 'Trường này là bắt buộc.',
    sending: 'Đang gửi…',
    step: 'Bước {step}/{total}',
    submit: 'Gửi',
    thanks: 'Cảm ơn bạn.',
  },
  zh: {
    back: '上一步',
    close: '关闭',
    closed: '此表单目前不接受回复。',
    failed: '发送失败，请重试。',
    invalid: '此回答无效。',
    next: '下一步',
    poweredBy: '由 Prodantix 提供支持',
    required: '此项为必填项。',
    sending: '正在发送…',
    step: '第 {step} 步，共 {total} 步',
    submit: '提交',
    thanks: '谢谢。',
  },
};

/** The page's language when the renderer speaks it, else English. */
export const formLanguage = (tag: string | null | undefined): FormLanguage => {
  const base = (tag ?? '').toLowerCase().split('-')[0] ?? '';
  return base in FORM_STRINGS ? (base as FormLanguage) : 'en';
};
